'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.filter("duree", function ($dureeFormat) {
  return function dureeFilter(value) {
    return $dureeFormat(value);
  };
});

/**
 * formatage d'un nombre de mois en années/mois : (ex : 276 –> 2 ans et 3 mois)
 * Params:  value – un nombre de mois
 */
ngModule.filter("dureeFromMois", function ($dureeFormat) {
  return function dureeFilter(value) {
    var dureeFromMois = $dureeFormat.dureeFromMois(value);
    return dureeFromMois;
  };
});

/**
 * formatage d'un nombre de minutes en j/h/mn : (ex : 90 –> 1 h 3 mn) - x j y h z mn
 *
 * Params:  value – un nombre de minutes
 */
ngModule.filter("dureeFromMinutes", function () {
  return function tempsFilter(dureeEnMin) {
    var m = dureeEnMin % 60;
    var h = Math.floor(dureeEnMin / 60) % 24;
    var j = Math.floor(dureeEnMin / (60 * 24));
    var res = "";
    if (j > 0) {
      res += j + " j ";
    }
    if (h > 0) {
      res += h + " h ";
    }
    res += m + " mn ";
    return res;
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/types/duree/duree-filters.js
// module id = 2726
// module chunks = 13